import { Button } from './Button';
import { SubmitBtn } from './SubmitBtn';
import { Login } from './Login';
import { Tab } from './Tab';

export default { Button, SubmitBtn, Login, Tab };
